module.exports = __webpack_public_path__ + "static/ZepProzess-bb1677669b043c3335c47ba395efdec1.png";